module.exports = __webpack_public_path__ + "img/appAsset-brand--Compliance.ec5ccfcd.svg";